/**
 * 통합 로깅 유틸리티
 * 개발 환경에서만 콘솔 로그를 출력하는 범용 함수들
 */

type LogLevel = 'log' | 'warn' | 'error' | 'info';

/**
 * 개발 환경에서만 콘솔 로그 출력
 * @param level - 로그 레벨 (log, warn, error, info)
 * @param message - 로그 메시지
 * @param data - 추가 데이터 (선택사항)
 */
function devLog(level: LogLevel, message: string, data?: any): void {
    // 개발 환경이거나 localhost에서 실행 중일 때만 로그 출력
    if (import.meta.env.DEV || window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        if (data !== undefined) {
            console[level](message, data);
        } else {
            console[level](message);
        }
    }
}

/**
 * 카테고리별 로거 생성 함수
 * @param category - 로그 카테고리 (예: "🔐 Auth", "🧭 Router")
 * @returns 카테고리가 포함된 로깅 함수들
 */
export function createLogger(category: string) {
    return {
        log: (message: string, data?: any) => devLog('log', `${category}: ${message}`, data),
        warn: (message: string, data?: any) => devLog('warn', `${category}: ${message}`, data),
        error: (message: string, data?: any) => devLog('error', `${category}: ${message}`, data),
        info: (message: string, data?: any) => devLog('info', `${category}: ${message}`, data),
    };
}

/**
 * 기본 로거 (카테고리 없음)
 */
export const logger = {
    log: (message: string, data?: any) => devLog('log', message, data),
    warn: (message: string, data?: any) => devLog('warn', message, data),
    error: (message: string, data?: any) => devLog('error', message, data),
    info: (message: string, data?: any) => devLog('info', message, data),
};

/**
 * 자주 사용되는 카테고리별 로거들
 */
export const authLogger = createLogger('🔐 Auth');
export const routerLogger = createLogger('🧭 Router');
export const appLogger = createLogger('🚀 App');
export const apiLogger = createLogger('🌐 API');